import React from 'react';
import { type StyleProp, StyleSheet, type ViewStyle } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, TitleText, useResponsive } from '@garnish/core';

import { LoyaltyHomeChallengesRewardsContainer } from '../LoyaltyHomeChallengesRewardsContainer';

export const LoyaltyHomeRewardsEmptyState = (props: EmptyStateProps) => {
  const { title, body, style, dataSet } = props;
  const { match, minWidth } = useResponsive();

  if (!minWidth.isSM) return null;

  return (
    <LoyaltyHomeChallengesRewardsContainer style={style} {...(dataSet ? { dataSet } : {})}>
      <TitleText style={styles.creamLabel} sizeMatch={['48']}>
        {title}
      </TitleText>

      <BodyText style={match([styles.centerLabel, styles.creamLabel])} sizeMatch={['18']}>
        {body}
      </BodyText>
    </LoyaltyHomeChallengesRewardsContainer>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  centerLabel: {
    textAlign: 'center',
  },
  creamLabel: {
    color: theme.colors.CREAM,
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type EmptyStateProps = {
  title: string;
  body: string;
  style: StyleProp<ViewStyle>;
  dataSet: Record<string, string>;
};
